module.exports = __webpack_public_path__ + "img/slide-codex.31557033.png";